import request from '../../../helpers/request';

const getFlatMeterAttachment = async (meterId, fileName) => {
  const response = await request.get(
    `/Meter/individual_meter/${meterId}/attachment`,
    { fileName },
    'Не удалось загрузить файл',
    'Error'
  );

  return response;
};

export default getFlatMeterAttachment;
